import useBrandSEO from "src/hooks/useBrandSEO";
import { Expandable } from "src/atoms/Expandable";
import { Box, Flex, useBreakpoints } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { ShopType } from "src/types/graphql.d";
import { useState } from "react";
import { Column, StyledButton } from "./BrandSEO.styled";
import { sanitize } from "isomorphic-dompurify";

const BrandSEO = ({
  brandSlug,
  shopType,
}: {
  brandSlug: string;
  shopType: ShopType;
}): JSX.Element | null => {
  const { isMobile } = useBreakpoints();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { data } = useBrandSEO({ brand_slug: brandSlug, shop_type: shopType });
  return data &&
    data.brandSEO.rightColumnHTML &&
    data.brandSEO.leftColumnHTML ? (
    <Box mb={96}>
      <Expandable minHeight={isMobile ? 164 : 104} isExpanded={isExpanded}>
        <Flex flexDirection={isMobile ? "column" : "row"}>
          <Column
            flex={1}
            mr={isMobile ? 0 : 4}
            dangerouslySetInnerHTML={{
              __html: sanitize(data.brandSEO.leftColumnHTML),
            }}
          />
          <Column
            flex={1}
            dangerouslySetInnerHTML={{
              __html: sanitize(data.brandSEO.rightColumnHTML),
            }}
          />
        </Flex>
      </Expandable>
      <Flex>
        <StyledButton
          variant="secondary"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? <Trans>Read less</Trans> : <Trans>Read more</Trans>}
        </StyledButton>
      </Flex>
    </Box>
  ) : null;
};

export default BrandSEO;
